import React from "react";
//스타일패키지
import styled from "styled-components";
//라우터
import { Link } from 'react-router-dom';
import { useHistory } from "react-router-dom";
//아이콘
import { TiPencil,TiTrash,TiTickOutline,TiTick } from "react-icons/ti";
import { HiPencilAlt } from "react-icons/hi";

//리덕스
import {useSelector,useDispatch} from "react-redux";
import { deleteWordFB, updateWordFB } from "../redux/modules/word";

const Main = (props) =>{
    const dispatch =useDispatch();
    const history =useHistory();
    const words =useSelector((state)=> state.word.list);
    //console.log(words)

    const deleteReal= (id) =>{ //삭제함수
        const password =prompt("삭제하시려면 yes를 입력해주세요!😮");
        if(password !== "yes"){
            alert('비밀번호가 틀렸습니다! 소문자로 yes를 입력해주세요!🤔');
            return;
        };
        dispatch(deleteWordFB(id));
    }
    
    return (
        <>
        <Outter>
            <WordBox>
                {words.map((list,idx) => {
                    return(
                    <div key={idx} id={list.id}
                    style={{backgroundColor: list.completed ?"#123389":"#e4ebfb",
                            color: list.completed ?"#fff":"#000"  }}
                    >
                        <div>단어
                            <p>{list.word}</p>
                        </div>
                        <div> 설명
                             <p>{list.desc}</p>
                        </div>
                        <div>예시
                            <p style={{color: list.completed ?"#fff":"#0046fd"}}>
                                {list.example}
                            </p>
                        </div>
                        <BtnBox>
                            <button style={{backgroundColor: list.completed ?"#123389":"#e4ebfb"}}
                                
                                onClick={()=>
                                //dispatch(updateWord(list.id))
                                dispatch(updateWordFB(list))
                            }> 
                            {list.completed ? <Ok/>: <Check/>}
                                {/* <Check/> */}
                            </button>
                            <Link to={{
                                pathname:'/modify/'+words[idx].id,
                                state:{id:words[idx].id,
                                        word:words[idx].word,
                                        desc:words[idx].desc,
                                        example:words[idx].example,
                                        completed:words[idx].completed
                                }
                            }}>
                                <button style={{backgroundColor: list.completed ?"#123389":"#e4ebfb"}}>
                                    <HiPencilAlt style={{color: list.completed ?"#fff":"#123389",
                                        width:"30px",height:"30px" }}/>
                                </button>
                            </Link>
                            <button style={{backgroundColor: list.completed ?"#123389":"#e4ebfb"}}
                                onClick={()=>{
                                    //dispatch(deleteWordFB(list.id));
                                    deleteReal(list.id);
                                    history.push("/");
                                }}>
                                    <Trash style={{color: list.completed ?"#fff":"#123389" }}/>
                            </button>
                        </BtnBox>
                    </div>
                    )
                })}
            </WordBox>
            <TopBtn onClick={()=>{
                    window.scrollTo({top:0,left:0, behavior:"smooth"});}}>
                TOP
            </TopBtn>
            <PlusBtn to="/word/add" >
                <Plus />
            </PlusBtn>
        </Outter>
        </>
        )
};

const Outter=styled.section`
    width:100%;
    position:relative;
    top:80px;
    min-height:800px;
    padding:48px;
    

    @media screen and (max-width: 500px){
        top:60px;
        padding:30px;
        }
`;
const WordBox =styled.div`
    width:1200px;
    margin: 0 auto;
    @media screen and (max-width: 1200px){
            width:100%;
        }

    & > div {
        width:30%;
        height:300px;
        padding:20px;
        position:relative;
        background:#e4ebfb;
        border:2px solid #123389;
        border-radius:8px;
        float:left;
        margin: 0 5% 30px 0;
        display:flex;
        flex-direction:column;
        justify-content: space-around;
        gap:30px;
        @media screen and (max-width: 960px){
            width:100%;
        }
    }
    & > div:nth-child(3n){
        margin-right:0;
    }
    & > div >div{
        font-family:"Dongle";
        font-size:32px;
    }
    & > div >div> p{
        font-family:"NotoSansKR";
        font-size:16px;
    }
    
`
const BtnBox=styled.div`
        position: absolute;
        top:10px;
        right:10px;
        display:flex;
        gap:10px;

        & > button{
            width:30px;
            height:30px;
            border-radius:15px;
            background:#e4ebfb;
            color:#123389;
            cursor:pointer;
        }
`;
const Check=styled(TiTickOutline)`
    width:30px;
    height:30px;
    color:#123389;
`;
const Ok=styled(TiTick)`
    width:30px;
    height:30px;
    color:#fff;
`
const Trash=styled(TiTrash)`
    width:30px;
    height:30px;
    
`;

const PlusBtn = styled(Link)`
 position:fixed;
 width:60px;
 height:60px;
 bottom:10px;
 right:10px;
 background-color:#123389;
 border-radius:30px;
 display:flex;
 justify-content:center;
 align-items:center;
`
const Plus=styled(TiPencil)`
    transform:scale(2,2);
    transition: transform 300ms ease-in-out;
    color:#fff;

    &:hover{
        transform: scale(2,2) rotate(360deg);
    }
`;
const TopBtn=styled.div`
    width:60px;
    height:60px;
    position:fixed;
    border-radius:30px;
    bottom:80px;
    right:10px;
    background:#123389;
    text-align:center;
    line-height:60px;
    color: #fff;
    font-family:"Dongle";
    font-size:34px;
    cursor:pointer;
`;
export default Main;